let singleton = Symbol();
let singletonEnforcer = Symbol();

class DeviceManager {
	static get instance() {
		if (!this[singleton]) {
			this[singleton] = new DeviceManager(singletonEnforcer);

			this[singleton].init();
		}

		return this[singleton];
	}

	constructor(enforcer) {
		if (enforcer != singletonEnforcer) throw new Error("Cannot construct singleton");
	}

	init() {
		const ua = navigator.userAgent.toLowerCase();
		const isAndroid = ua.indexOf("android") > -1;
		const isIOS = /ipad|iphone|ipod/.test(ua) && !window.MSStream;

		if(isAndroid || isIOS) {
			document.documentElement.classList.add('touch');
		} else {
			document.documentElement.classList.add('no-touch');
		}
	}
}

export default DeviceManager.instance;
